import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    AfterViewInit,
    ViewChild,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { SeErrorStateMatcher } from '../../../utils/error-state-matcher';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'se-combo-cell-editor-popup',
    templateUrl: './combo-cell-editor-popup.component.html',
    styleUrls: ['./combo-cell-editor-popup.component.scss'],
})
export class ComboCellEditorPopupComponent implements OnInit, AfterViewInit {
    /**
     * specify the space available for the popup editor
     * passed by NumericCellEditorComponent as cellWidth
     */
    @Input() width!: string;

    /**
     * Current value of the cell
     * ngModel setted by AlphanumericCellEditorComponent
     */
    @Input() value: any;

    /**
     * it defines option list, can be string or object array
     */
    @Input() dataSource!: Array<any>;

    /**
     * it allows to specify which object property to show in drop down list.
     */
    @Input() viewValueFieldName?: string;

    /**
     * it allows to specify which object property to give back(ngModel).If it is null or undefined, the component gives back all the object.
     */
    @Input() valueFieldName?: string;

    /**
     * (Optional default value false) it allows multi selection.
     */
    @Input() multi!: boolean;

    /**
     * (Optional default value false) it allows to reset the cell value
     */
    @Input() isResettable!: boolean;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required!: boolean;

    /**
     * Event emitted when the reactive form is ready
     */
    @Output() formReady: EventEmitter<AbstractControl> = new EventEmitter<AbstractControl>();

    @Output() tabEvent: EventEmitter<any> = new EventEmitter();

    /**
     * Event emitted when the dropdown list is closed
     */
    @Output() selectionClosed: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(MatSelect, { static: false }) comboInput!: MatSelect;
    @ViewChildren(MatOption) matOptions!: QueryList<MatOption>;

    comboForm!: FormGroup;
    matcher = new SeErrorStateMatcher();
    private isComboOpened = false;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.comboForm = this.formBuilder.group({
            selection: [this.value, this.required ? [Validators.required] : []],
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.comboInput.focus();
        }, 0);
        const control = this.comboForm.get('selection');
        if (!!control) this.formReady.emit(control);
    }

    compareWithFn(item1: any, item2: any) {
        item1 = item1 || '';
        item2 = item2 || '';
        if (typeof item1 === 'string' && typeof item2 === 'string') {
            return item1 === item2;
        }
        if (typeof item1 === 'object' && typeof item2 === 'object') {
            if ('Id' in item1 && 'Id' in item2) {
                return item1.Id === item2.Id;
            }
            let result = true;
            Object.entries(item1).forEach((prop) => {
                result = result && prop[1] === item2[prop[0]];
            });
            return result;
        }
    }

    _onOpenedChange(openedToggle: boolean) {
        this.isComboOpened = openedToggle;
        if (openedToggle === false) {
            this.selectionClosed.emit();
        } else {
            if (!this.multi) {
                const selected = this.comboInput.selected as MatOption;
                if (selected) {
                    selected.focus();
                }
            }
        }
    }

    _onCleanCombo(event: Event) {
        this.comboForm.setValue({ selection: null });
        //this.selectionClosed.emit(); // eliminare il commento per abilitare la chiusura immediata della pop-up
        event.stopPropagation();
    }

    onKeydown(event: KeyboardEvent) {
        const key = event.keyCode;
        if (event.keyCode === 9 && !event.shiftKey) {
            event.preventDefault();
            this.tabEvent.emit(); // disabilitata perchè sembra fosse solo per le pinned
        }
        if (this.isComboOpened && !this.multi && (key === 38 || key === 40)) {
            //40 down, 38 up
            this.moveFocusBetweenOptions(key);
        }
    }

    moveFocusBetweenOptions(key: number) {
        const increment = key === 38 ? -1 : 1,
            matOptionsArray = this.matOptions.toArray(),
            selected = this.comboInput.selected as MatOption,
            selectedIndex = selected ? matOptionsArray.findIndex((option) => option.id === selected.id) : null;
        if (selectedIndex !== null) {
            const nextOption = matOptionsArray[selectedIndex + increment];
            if (nextOption) {
                nextOption.focus();
                nextOption.select();
            }
        } else {
            if (increment === -1) {
                return;
            }
            matOptionsArray[0].focus();
            matOptionsArray[0].select();
        }
    }
}
